import React from "react";
import { Box, Dialog, Typography, Button } from "@mui/material";

import { makeStyles } from "@mui/styles";
import clsx from "clsx";

const useStyles = makeStyles(() => ({
  root: {
    minWidth: 200,
    padding: 30,
    borderRadius: 10,
    display: "flex",
    flexDirection: "column",
    fontSize: 14,
  },
  title: {
    fontWeight: "700",
    color: "#000",
    fontSize: 18,
  },

  buttonBox: {
    marginTop: 53,
    marginLeft: "auto",
  },
  button: {
    padding: "9px 23px",
    borderRadius: 4,
    fontWeight: "700",
    fontSize: 12,
    color: "#6B6F7E",
  },
  saveButton: {
    backgroundColor: "#6B6F7E",
    color: "#FFF",
    "&:hover": {
      backgroundColor: "rgb(101 101 101 / 36%)",
    },
  },
  link: {
    borderBottom: "1px solid #dfdfdf",
    padding: 10,
    color: "#044ba1",
    cursor: "pointer",
    marginTop: 10,
  },
}));

const PageCompose = ({ open, handleClose }) => {
  const classes = useStyles();

  return (
    <Dialog onClose={handleClose} open={open} classes={{ paper: classes.root }}>
      <Typography className={classes.title}>Цагийн хуваарь</Typography>
      <Box className="mt-[10px] mb-[20px]">
        <Typography className="text-[gray]">
          Та өөрт хэрэгтэй заавар сургалтыг доорх линкэд дарж үзнэ үү.
        </Typography>
        <Box
          className={classes.link}
          onClick={() =>
            window.open(
              "https://www.facebook.com/ankhzaya.badamsvren/videos/842923468018583/?idorvanity=334457404293936",
              "_blank"
            )
          }
        >
          1. Барааныхаа трак кодыг хэрхэн харах вэ
        </Box>
        <Box
          className={classes.link}
          onClick={() =>
            window.open(
              "https://www.facebook.com/ankhzaya.badamsvren/videos/842923468018583/?idorvanity=334457404293936",
              "_blank"
            )
          }
        >
          1. Барааныхаа трак кодыг хэрхэн харах вэ
        </Box>
        <Box
          className={classes.link}
          onClick={() =>
            window.open(
              "https://www.facebook.com/ankhzaya.badamsvren/videos/842923468018583/?idorvanity=334457404293936",
              "_blank"
            )
          }
        >
          1. Барааныхаа трак кодыг хэрхэн харах вэ
        </Box>
        <Box
          className={classes.link}
          onClick={() =>
            window.open(
              "https://www.facebook.com/ankhzaya.badamsvren/videos/842923468018583/?idorvanity=334457404293936",
              "_blank"
            )
          }
        >
          1. Барааныхаа трак кодыг хэрхэн харах вэ
        </Box>
        <Box
          className={classes.link}
          onClick={() =>
            window.open(
              "https://www.facebook.com/ankhzaya.badamsvren/videos/842923468018583/?idorvanity=334457404293936",
              "_blank"
            )
          }
        >
          1. Барааныхаа трак кодыг хэрхэн харах вэ
        </Box>
        <Box
          className={classes.link}
          onClick={() =>
            window.open(
              "https://www.facebook.com/ankhzaya.badamsvren/videos/842923468018583/?idorvanity=334457404293936",
              "_blank"
            )
          }
        >
          1. Барааныхаа трак кодыг хэрхэн харах вэ
        </Box>
        <Box
          className={classes.link}
          onClick={() =>
            window.open(
              "https://www.facebook.com/ankhzaya.badamsvren/videos/842923468018583/?idorvanity=334457404293936",
              "_blank"
            )
          }
        >
          1. Барааныхаа трак кодыг хэрхэн харах вэ
        </Box>
        <Box
          className={classes.link}
          onClick={() =>
            window.open(
              "https://www.facebook.com/ankhzaya.badamsvren/videos/842923468018583/?idorvanity=334457404293936",
              "_blank"
            )
          }
        >
          1. Барааныхаа трак кодыг хэрхэн харах вэ
        </Box>
      </Box>
      <Box className={classes.buttonBox}>
        <Button className={classes.saveButton} onClick={handleClose}>
          Цонхыг хаах
        </Button>
      </Box>
    </Dialog>
  );
};

export default PageCompose;
